<script lang="ts">
  import CoffeeBean from '$lib/components/icons/CoffeeBean.svelte';
  import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
  import { getBeanNameById, userProfile } from '$lib/PersistedState.svelte';
  import type { Component } from '$lib/types/RoastLog';
  import { Pencil } from '@lucide/svelte';

  let {
    index = -1,
    components,
    startingMass,
    qItemToEditIndex = $bindable(),
    dialogOpen = $bindable(false)
  }: {
    index: number;
    components: Component[];
    startingMass: number | undefined;
    qItemToEditIndex: number | null;
    dialogOpen: boolean;
  } = $props();

  const massScale = userProfile.current?.profile.mass_scale;

  const getAmount = (percentage: number) => {
    if (!startingMass) {
      return '';
    }
    const amount = startingMass * (percentage / 100);
    return `- ${amount.toFixed(1)} ${massScale}`;
  };
</script>

<DropdownMenu.Sub>
  <DropdownMenu.SubTrigger>
    <Pencil class="mr-2 size-4" />
    <span>Recipe</span>
  </DropdownMenu.SubTrigger>
  <DropdownMenu.SubContent>
    {#each components as bean}
      <DropdownMenu.Item>
        <CoffeeBean />
        {getBeanNameById(bean.bean_id)}:
        <span class="font-semibold">
          {bean.percent}% {getAmount(bean.percent)}
        </span>
      </DropdownMenu.Item>
    {/each}
    <DropdownMenu.Separator></DropdownMenu.Separator>
    <DropdownMenu.Item
      class="hover:cursor-pointer"
      onclick={() => {
        qItemToEditIndex = index;
        dialogOpen = true;
      }}
    >
      <Pencil class="mr-2 h-4 w-4 " /> Edit recipe
    </DropdownMenu.Item>
  </DropdownMenu.SubContent>
</DropdownMenu.Sub>
